import React, { useEffect, useMemo, useState } from "react";
import { Box, Grid, Card, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, Button, Chip, Tabs, Tab, CircularProgress, IconButton } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { makeStyles } from "@material-ui/core/styles";
import EventNoteIcon from "@material-ui/icons/EventNote";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import BusinessIcon from "@material-ui/icons/Business";
import CreateIcon from "@material-ui/icons/Create";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import RateReviewIcon from "@material-ui/icons/RateReview";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import EventIcon from "@material-ui/icons/Event";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import VideocamIcon from "@material-ui/icons/Videocam";
import GetAppIcon from "@material-ui/icons/GetApp";
import StudentCards from "./UserProfileCard";
import StudentService from "./Locality/Service/studentService";
import ActivityService from "./Locality/Service/activityService";
const useStyles = makeStyles((theme) => ({
    pageContainer: {
        maxWidth: 1080,
        margin: "0 auto",
        padding: theme.spacing(3),
        backgroundColor: "#f8fafc",
    },
    studentSelectorCard: {
        borderRadius: 18,
        padding: theme.spacing(1),
        marginBottom: theme.spacing(3),
        background: "#ffffff",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
    },
    heroCard: {
        borderRadius: 24,
        padding: theme.spacing(3.5),
        background: "linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)",
        border: "1px solid #e2e8f0",
        boxShadow: "0 12px 32px rgba(15, 23, 42, 0.08)",
    },
    section: {
        marginTop: theme.spacing(4),
    },
    sectionCard: {
        borderRadius: 20,
        padding: theme.spacing(2.5),
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)",
    },
    sectionTitle: {
        fontWeight: 800,
        color: "#1e3a8a",
        textAlign: "center",
        marginBottom: theme.spacing(3),
        letterSpacing: 0.4,
    },
    subTitle: {
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: theme.spacing(2),
    },
    tablePaper: {
        overflow: "hidden",
        borderRadius: 16,
        border: "1px solid #e5e7eb",
        boxShadow: "none",
    },
    headCell: {
        fontWeight: 700,
        background: "#eff6ff",
        color: "#1e3a8a",
    },
    bodyCell: {
        color: "#334155",
    },
    profileCard: {
        borderRadius: 16,
    },
    profileAvatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    introLabel: {
        color: "#64748b",
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    heroName: {
        fontWeight: 800,
        color: "#ea580c",
        textTransform: "uppercase",
        marginBottom: theme.spacing(2),
    },
    infoGrid: {
        marginBottom: theme.spacing(2),
    },
    infoCard: {
        backgroundColor: "#f8fafc",
        borderRadius: 14,
        padding: theme.spacing(1.5, 2),
        border: "1px solid #e2e8f0",
    },
    infoLabel: {
        color: "#64748b",
        fontSize: "0.8rem",
        marginBottom: theme.spacing(0.5),
    },
    infoValue: {
        color: "#0f172a",
        fontWeight: 700,
    },
    heroDescription: {
        color: "#475569",
        lineHeight: 1.8,
        maxWidth: 620,
    },
    avatarWrap: {
        display: "flex",
        justifyContent: "center",
    },
    heroAvatar: {
        width: 180,
        height: 180,
        border: "6px solid #ffffff",
        boxShadow: "0 12px 32px rgba(37, 99, 235, 0.18)",
        backgroundColor: "#dbeafe",
    },
    statsGrid: {
        marginTop: theme.spacing(3),
    },
    statCard: {
        borderRadius: 16,
        padding: theme.spacing(2),
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
        height: "100%",
    },
    statLabel: {
        color: "#64748b",
        fontSize: "0.85rem",
        marginBottom: theme.spacing(1),
    },
    statValue: {
        color: "#0f172a",
        fontSize: "1.7rem",
        fontWeight: 800,
        lineHeight: 1.1,
    },
    clickableValue: {
        color: "#1d4ed8",
        fontWeight: 700,
        cursor: "pointer",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    clickableButton: {
        minWidth: 46,
        minHeight: 34,
        borderRadius: 10,
        padding: theme.spacing(0.5, 1.5),
        fontWeight: 800,
        color: "#1d4ed8",
        backgroundColor: "#eff6ff",
        border: "1px solid #bfdbfe",
        textTransform: "none",
        "&:hover": {
            backgroundColor: "#dbeafe",
            borderColor: "#93c5fd",
        },
    },
    emptyState: {
        padding: theme.spacing(4),
        textAlign: "center",
        color: "#64748b",
    },
    dialogList: {
        minWidth: 320,
        padding: 0,
    },
    dialogPaper: {
        borderRadius: 20,
        overflow: "hidden",
    },
    dialogTitle: {
        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        color: "#1e3a8a",
        fontWeight: 800,
        padding: theme.spacing(2.5, 3),
        borderBottom: "1px solid #dbeafe",
    },
    dialogSubtitle: {
        color: "#64748b",
        marginBottom: theme.spacing(2),
    },
    dialogContent: {
        padding: theme.spacing(2, 3),
        backgroundColor: "#f8fafc",
    },
    activityItem: {
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 14,
        marginBottom: theme.spacing(1.5),
        padding: theme.spacing(1, 1.5),
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.04)",
        alignItems: "flex-start",
    },
    activityIndex: {
        minWidth: 30,
        height: 30,
        borderRadius: "50%",
        backgroundColor: "#dbeafe",
        color: "#1d4ed8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        marginRight: theme.spacing(1.5),
        fontSize: "0.85rem",
    },
    activityName: {
        color: "#0f172a",
        fontWeight: 600,
    },
    activityMetaRow: {
        display: "grid",
        gridTemplateColumns: "120px 1fr",
        gap: theme.spacing(1),
        marginTop: theme.spacing(0.5),
    },
    activityMetaLabel: {
        color: "#64748b",
        fontSize: "0.78rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.3,
    },
    activityMetaValue: {
        color: "#1e293b",
        fontSize: "0.92rem",
        fontWeight: 500,
        wordBreak: "break-word",
    },
    dialogActions: {
        padding: theme.spacing(1.5, 3, 2.5),
        backgroundColor: "#f8fafc",
        borderTop: "1px solid #e2e8f0",
    },
    closeButton: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 700,
        padding: theme.spacing(1, 2.5),
    },
    notesSectionCard: {
        borderRadius: 16,
        backgroundColor: "#ffffff",
        border: "1px solid #e6eaf0",
        boxShadow: "0 2px 12px rgba(16, 42, 67, 0.06)",
        overflow: "hidden",
    },
    notesSectionHeader: {
        display: "flex",
        alignItems: "flex-start",
        gap: theme.spacing(1.5),
        padding: theme.spacing(2.5, 2.5, 1.5),
    },
    notesHeaderIcon: {
        width: 44,
        height: 44,
        borderRadius: 12,
        backgroundColor: "#eef4ff",
        color: "#1769d6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    notesHeaderTitle: {
        fontWeight: 700,
        fontSize: "1.35rem",
        color: "#0f2d4d",
        lineHeight: 1.25,
    },
    notesHeaderSubtitle: {
        color: "#6b7280",
        fontSize: "0.875rem",
        marginTop: 4,
    },
    notesTabsWrap: {
        borderBottom: "1px solid #eef1f5",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    notesTabs: {
        minHeight: 48,
    },
    notesTab: {
        textTransform: "none",
        fontWeight: 600,
        fontSize: "0.9rem",
        minHeight: 48,
        minWidth: 100,
        opacity: 1,
        color: "#64748b",
        "&$notesTabSelected": {
            color: "#1769d6",
        },
    },
    notesTabSelected: {},
    notesTabLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
    },
    notesListWrap: {
        padding: theme.spacing(2, 2.5),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
        minHeight: 120,
    },
    noteListCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: 14,
        border: "1px solid #e6eaf0",
        backgroundColor: "#ffffff",
        transition: "box-shadow 0.2s ease",
        "&:hover": {
            boxShadow: "0 4px 16px rgba(16, 42, 67, 0.08)",
        },
    },
    noteTypeIconBox: {
        width: 48,
        height: 48,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    noteTypeIconTeacher: {
        backgroundColor: "#eef4ff",
        color: "#1769d6",
    },
    noteTypeIconSchool: {
        backgroundColor: "#ecfdf5",
        color: "#059669",
    },
    noteCardBody: {
        flex: 1,
        minWidth: 0,
    },
    noteCardTitle: {
        color: "#0f172a",
        fontWeight: 700,
        fontSize: "0.95rem",
        lineHeight: 1.5,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        marginBottom: theme.spacing(1),
    },
    noteCardMeta: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(1),
        color: "#64748b",
        fontSize: "0.8rem",
    },
    noteMetaItem: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
    },
    noteMetaDivider: {
        color: "#cbd5e1",
        userSelect: "none",
    },
    noteSourceChip: {
        height: 22,
        fontSize: "0.72rem",
        fontWeight: 700,
        borderRadius: 6,
    },
    teacherChip: {
        backgroundColor: "#eef4ff",
        color: "#1769d6",
    },
    schoolChip: {
        backgroundColor: "#ecfdf5",
        color: "#059669",
    },
    notesPagination: {
        borderTop: "1px solid #eef1f5",
        backgroundColor: "#fafbfc",
        "& .MuiTablePagination-toolbar": {
            minHeight: 52,
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2),
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
            fontSize: "0.85rem",
            color: "#64748b",
        },
    },
    notesEmptyState: {
        padding: theme.spacing(5, 2),
        textAlign: "center",
        color: "#64748b",
        fontSize: "0.9rem",
    },
    questionnaireListWrap: {
        padding: theme.spacing(2, 2.5, 2.5),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
    },
    questionnaireMetaRow: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    questionnaireItem: {
        borderRadius: 12,
        border: "1px solid #e2e8f0",
        backgroundColor: "#f8fafc",
        padding: theme.spacing(1.75, 2),
    },
    questionnaireQuestion: {
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: theme.spacing(0.75),
    },
    questionnaireAnswer: {
        color: "#334155",
        lineHeight: 1.6,
    },
    questionnaireMetaText: {
        color: "#64748b",
        fontSize: "0.85rem",
    },
    milestoneAlbumCard: {
        borderRadius: 14,
        border: "1px solid #e2e8f0",
        backgroundColor: "#f8fafc",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    milestoneAlbumTitle: {
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: theme.spacing(0.5),
    },
    milestoneAlbumMeta: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        color: "#64748b",
        fontSize: "0.85rem",
        marginBottom: theme.spacing(1.5),
    },
    milestonePhotoTile: {
        position: "relative",
        width: "100%",
        paddingTop: "100%",
        borderRadius: 12,
        overflow: "hidden",
        cursor: "pointer",
        backgroundColor: "#e2e8f0",
        border: "1px solid #cbd5e1",
    },
    milestonePhotoImage: {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    milestoneLightboxPaper: {
        backgroundColor: "rgba(15, 23, 42, 0.95)",
        boxShadow: "none",
        maxWidth: "96vw",
        maxHeight: "96vh",
    },
    milestoneLightboxContent: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: theme.spacing(2),
    },
    milestoneLightboxImage: {
        maxWidth: "100%",
        maxHeight: "72vh",
        objectFit: "contain",
        borderRadius: 8,
    },
    milestoneLightboxClose: {
        position: "absolute",
        top: 8,
        right: 8,
        color: "#ffffff",
        backgroundColor: "rgba(255,255,255,0.12)",
    },
    milestoneLightboxNav: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#ffffff",
        backgroundColor: "rgba(255,255,255,0.12)",
    },
    milestoneMediaPlayTile: {
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0f172a",
        color: "#ffffff",
    },
    milestoneMediaAudioTile: {
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#eef4ff",
        color: "#1769d6",
        gap: 4,
    },
    milestoneMediaTypeBadge: {
        position: "absolute",
        bottom: 6,
        left: 6,
        fontSize: "0.65rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        padding: "2px 6px",
        borderRadius: 4,
        backgroundColor: "rgba(15, 23, 42, 0.72)",
        color: "#fff",
    },
    milestoneLightboxVideo: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "72vh",
        outline: "none",
        borderRadius: 8,
    },
    milestoneLightboxAudioWrap: {
        width: "100%",
        maxWidth: 480,
        padding: theme.spacing(3),
        textAlign: "center",
    },
    milestoneLightboxFooter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: theme.spacing(1.5),
        padding: "8px 16px 20px",
    },
    milestoneLightboxMeta: {
        color: "#e2e8f0",
        textAlign: "center",
    },
    milestoneDownloadBtn: {
        color: "#e2e8f0",
        borderColor: "rgba(255,255,255,0.35)",
        textTransform: "none",
        fontWeight: 600,
        "&:hover": {
            borderColor: "#ffffff",
            backgroundColor: "rgba(255,255,255,0.08)",
        },
    },
    milestoneSectionLabel: {
        fontSize: "0.75rem",
        fontWeight: 700,
        color: "#64748b",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(0.5),
    },
}));

const isPublishedMilestoneAlbum = (album) =>
    String(album?.status || "").toLowerCase() === "published";

const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;
const AUDIO_EXT = /\.(mp3|wav|ogg|m4a|aac|flac|mpeg)(\?|$)/i;

const getMediaTypeFromUrl = (url) => {
    if (!url || typeof url !== "string") return "image";
    const lower = url.split("?")[0].toLowerCase();
    if (VIDEO_EXT.test(lower)) return "video";
    if (AUDIO_EXT.test(lower)) return "audio";
    return "image";
};

const getDownloadFileName = (url, eventName, mediaType) => {
    const base = (eventName || "memory").replace(/[^\w.-]+/g, "_").slice(0, 60);
    const fromUrl = (url || "").split("?")[0].split("/").pop() || "";
    if (fromUrl && fromUrl.includes(".")) return fromUrl;
    const ext = mediaType === "video" ? "mp4" : mediaType === "audio" ? "mp3" : "jpg";
    return `${base}.${ext}`;
};

const downloadMilestoneMedia = async (url, eventName, mediaType) => {
    if (!url) return;
    const filename = getDownloadFileName(url, eventName, mediaType);
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("fetch failed");
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    } catch {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

const groupMilestoneMediaByType = (urls) => {
    const groups = { image: [], video: [], audio: [] };
    (urls || []).filter(Boolean).forEach((url, index) => {
        const mediaType = getMediaTypeFromUrl(url);
        groups[mediaType].push({ url, index, mediaType });
    });
    return groups;
};

const formatMilestoneDate = (value) => {
    if (!value) return "—";
    const s = String(value).trim();
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return s;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

export default function MyStoryPage() {
    const classes = useStyles();
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [monthWiseAttendance, setMonthWiseAttendance] = useState([]);
    const [activityPerformance, setActivityPerformance] = useState({});
    const [studentEvent, setStudentEvent] = useState({});
    const [activityDialog, setActivityDialog] = useState({
        open: false,
        title: "",
        items: [],
    });
    const [isActivityDialogLoading, setIsActivityDialogLoading] = useState(false);
    const [studentNotesList, setStudentNotesList] = useState([]);
    const [notesLoading, setNotesLoading] = useState(false);
    const [notesTab, setNotesTab] = useState("all");
    const [notesPage, setNotesPage] = useState(0);
    const [notesRowsPerPage, setNotesRowsPerPage] = useState(10);
    const [questionnaireLoading, setQuestionnaireLoading] = useState(false);
    const [questionnaireReport, setQuestionnaireReport] = useState({
        title: "Teacher Assessment",
        activeAcademicYear: "",
        rated: false,
        assessedBy: null,
        items: [],
    });
    const [milestoneAlbums, setMilestoneAlbums] = useState([]);
    const [milestoneLoading, setMilestoneLoading] = useState(false);
    const [milestoneLightbox, setMilestoneLightbox] = useState({ open: false, index: 0 });

    const milestoneMediaItems = useMemo(() => {
        const items = [];
        (milestoneAlbums || []).forEach((album) => {
            (album.imageURL || []).forEach((url) => {
                if (url) {
                    items.push({
                        url,
                        eventName: album.eventName || "Memory",
                        date: album.date,
                        mediaType: getMediaTypeFromUrl(url),
                    });
                }
            });
            (album.videoURL || []).forEach((url) => {
                if (url) {
                    items.push({
                        url,
                        eventName: album.eventName || "Memory",
                        date: album.date,
                        mediaType: "video",
                    });
                }
            });
        });
        return items;
    }, [milestoneAlbums]);

    const milestoneAlbumStarts = useMemo(() => {
        let offset = 0;
        return (milestoneAlbums || []).map((album) => {
            const start = offset;
            offset +=
                (album.imageURL || []).filter(Boolean).length +
                (album.videoURL || []).filter(Boolean).length;
            return start;
        });
    }, [milestoneAlbums]);

    const [studentList, setStudentList] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    useEffect(() => {
        fetchStudentList();

    }, []);
    const [selectedStudent, setSelectedStudent] = useState(null);

    useEffect(() => {
        if (!selectedStudentId && studentList.length > 0) {
            const firstStudent = studentList[0];
            if (firstStudent?._id) {
                const firstClassId =
                    firstStudent?.classId?._id || firstStudent?.classId || "";
                handleStudentClick(firstStudent._id, firstClassId, firstStudent.dob);
            }
        }
    }, [studentList, selectedStudentId]);

    useEffect(() => {
        if (studentId) {
            getStudentNotes(studentId);
            getStudentQuestionnaire(studentId);
            getStudentMilestoneImages(studentId);
            setNotesTab("all");
            setNotesPage(0);
        } else {
            setStudentNotesList([]);
            setMilestoneAlbums([]);
            setQuestionnaireReport({
                title: "Teacher Assessment",
                activeAcademicYear: "",
                rated: false,
                assessedBy: null,
                items: [],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studentId]);

    useEffect(() => {
        setNotesPage(0);
    }, [notesTab]);

    const onStudentSelect = (id, classId) => {
        const student = studentList.find((s) => {
            if (String(s._id) !== String(id)) return false;
            if (!classId) return true;
            const studentClassId = s.classId?._id || s.classId;
            return String(studentClassId) === String(classId);
        });

        if (!student) return;
        const age = calculateAge(student.dob);
        setSelectedStudent({
            ...student,
            age,
        });
    };

    const resolveSchoolId = (student) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        return (
            student?.schooleId?._id ||
            student?.schooleId ||
            report?.schooleId?._id ||
            report?.schooleId ||
            report?.schoolId?._id ||
            report?.schoolId ||
            null
        );
    };

    const handleStudentClick = (studentId, classId, dob) => {
        setStudentId(studentId);
        setClassId(classId);
        setSelectedStudentId(studentId);
        onStudentSelect(studentId, classId);
        getMonthWiseAttendance(studentId);
        getStudentActivityPerformance(studentId);
        getStudentEvent(studentId, classId);
    };
    const calculateAge = (dob) => {
        if (!dob) return null;
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };
    const getStudentNotes = (sid) => {
        if (!sid) {
            setStudentNotesList([]);
            return;
        }

        const student = studentList.find((s) => String(s._id) === String(sid));
        const schooleId = resolveSchoolId(student);

        setNotesLoading(true);
        StudentService.getStudentReportNotes(sid, { schooleId })
            .then((res) => {
                setStudentNotesList(Array.isArray(res) ? res : []);
            })
            .catch((err) => {
                console.error("Error fetching student notes", err);
                setStudentNotesList([]);
            })
            .finally(() => {
                setNotesLoading(false);
            });
    };

    const getStudentMilestoneImages = (sid) => {
        if (!sid) {
            setMilestoneAlbums([]);
            return;
        }

        const student = studentList.find((s) => String(s._id) === String(sid));
        const schooleId = resolveSchoolId(student);

        setMilestoneLoading(true);
        StudentService.getStudentMilestoneImages(sid, { schooleId })
            .then((res) => {
                const published = (Array.isArray(res) ? res : []).filter(isPublishedMilestoneAlbum);
                setMilestoneAlbums(published);
            })
            .catch((err) => {
                console.error("Error fetching milestone images", err);
                setMilestoneAlbums([]);
            })
            .finally(() => {
                setMilestoneLoading(false);
            });
    };

    const getStudentQuestionnaire = (sid) => {
        if (!sid) {
            setQuestionnaireReport({
                title: "Teacher Assessment",
                activeAcademicYear: "",
                rated: false,
                assessedBy: null,
                items: [],
            });
            return;
        }

        const student = studentList.find((s) => String(s._id) === String(sid));
        const schooleId = resolveSchoolId(student);

        setQuestionnaireLoading(true);
        StudentService.getStudentQuestionnaireReport(sid, { schooleId })
            .then((res) => {
                const data = res || {};
                setQuestionnaireReport({
                    title: data.title || "Teacher Assessment",
                    activeAcademicYear: data.activeAcademicYear || "",
                    rated: !!data.rated,
                    assessedBy: data.assessedBy || null,
                    items: Array.isArray(data.items) ? data.items : [],
                });
            })
            .catch((err) => {
                console.error("Error fetching teacher questionnaire", err);
                setQuestionnaireReport({
                    title: "Teacher Assessment",
                    activeAcademicYear: "",
                    rated: false,
                    assessedBy: null,
                    items: [],
                });
            })
            .finally(() => {
                setQuestionnaireLoading(false);
            });
    };

    const formatNoteDateTime = (value) => {
        if (!value) return "—";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return "—";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    };

    const isTeacherNote = (note) =>
        String(note?.userId?.role || "").toUpperCase() === "TEACHER";

    const filteredStudentNotes = studentNotesList.filter((note) => {
        if (notesTab === "teacher") return isTeacherNote(note);
        if (notesTab === "school") return !isTeacherNote(note);
        return true;
    });

    const teacherNotesCount = studentNotesList.filter(isTeacherNote).length;
    const schoolNotesCount = studentNotesList.length - teacherNotesCount;

    const paginatedStudentNotes = filteredStudentNotes.slice(
        notesPage * notesRowsPerPage,
        notesPage * notesRowsPerPage + notesRowsPerPage
    );

    const handleNotesTabChange = (_, value) => {
        setNotesTab(value);
    };

    const handleNotesPageChange = (_, newPage) => {
        setNotesPage(newPage);
    };

    const handleNotesRowsPerPageChange = (event) => {
        setNotesRowsPerPage(parseInt(event.target.value, 10));
        setNotesPage(0);
    };

    const getMonthWiseAttendance = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentAttendanceSummary(studentId, keys)
            .then((res) => {
                setMonthWiseAttendance(Array.isArray(res?.data) ? res.data : []);
            })
            .catch((err) => {
                console.error("Error fetching student attendance summary", err);
                setMonthWiseAttendance([]);
            });
    };


    const getStudentEvent = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentAssignmentSummary(studentId, keys)
            .then((res) => {
                setStudentEvent(res || {});
            })
            .catch((err) => {
                console.error("Error fetching student assignment summary", err);
                setStudentEvent({
                    submitted: 0,
                    notSubmitted: 0,
                    resubmitSubmitted: 0,
                    resubmitNotSubmitted: 0,
                    total: 0,
                });
            });
    };
    const getStudentActivityPerformance = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentActivitySummary(studentId, keys)
            .then((res) => {
                setActivityPerformance(res || {});
            })
            .catch((err) => {
                console.error("Error fetching student activity summary", err);
                setActivityPerformance({
                    totalActivities: 0,
                    strongArea: 0,
                    developingArea: 0,
                    needsAction: 0,
                    totalActivityNames: [],
                    strongAreaNames: [],
                    developingAreaNames: [],
                    needsActionNames: [],
                });
            });
    };

    const fetchStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const body = {};

        if (userDetails.role === "PARENT") {
            body.userId = userDetails._id;
        } else if (userDetails.role === "SCHOOLE" || userDetails.role === "SUPERADMIN") {
            body.schooleId = userDetails.schooleId || userDetails.schoolId;
        } else if (userDetails.role === "TEACHER") {
            body.schooleId = userDetails.schooleId || userDetails.schoolId;
            if (userDetails.classId) body.classId = userDetails.classId;
            if (userDetails.sectionId) body.sectionId = userDetails.sectionId;
        }

        StudentService.findStudentList(body)
            .then((res) => {
                const mappedStudents = (res || []).map((student) => ({
                    ...student,
                    fullName: `${student.firstName || ""} ${student.lastName || ""}`.trim(),
                }));
                setStudentList(mappedStudents);
            })
            .catch((err) => console.error(err));
    };
    // const attendanceRows = [
    //     { month: "Jan", presentDays: 20, absentDays: 2, lateDays: 1 },
    //     { month: "Feb", presentDays: 18, absentDays: 3, lateDays: 0 },
    // ];

    // const activityPerformanceRows = [
    //     { activity: "Drawing", score: "A+" },
    //     { activity: "Reading", score: "A" },
    // ];


    const getMonthName = (monthNumber) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        // monthNumber: 1 for Jan, 12 for Dec
        return monthNames[monthNumber - 1] || "";
    };

    const hasSubActivityName = (name) => {
        const s = String(name || "").trim();
        return Boolean(s && s !== "—" && s !== "N/A");
    };

    const getActivityDetailsFromResponse = (response = []) => {
        const seen = new Set();
        const details = [];

        (response || []).forEach((activity) => {
            (activity?.activityRecordsId || []).forEach((record) => {
                const activityName =
                    record?.activityId?.activityName ||
                    activity?.activityId?.activityName ||
                    "";
                if (!activityName) return;

                const subActivityName =
                    record?.subActivityId?.subActivityName ||
                    activity?.subActivityId?.subActivityName ||
                    "";

                const key = hasSubActivityName(subActivityName)
                    ? `${activityName}||${subActivityName}`
                    : activityName;
                if (seen.has(key)) return;
                seen.add(key);
                details.push({
                    activityName,
                    subActivityName: hasSubActivityName(subActivityName) ? subActivityName : "",
                });
            });
        });

        return details;
    };

    /** Group flat rows by activity; each activity lists its related sub-activities (exercises). */
    const groupActivityDetails = (flatItems = []) => {
        const map = new Map();
        (flatItems || []).forEach((item) => {
            const activityName = item?.activityName || "N/A";
            if (!map.has(activityName)) {
                map.set(activityName, { activityName, exercises: [] });
            }
            const group = map.get(activityName);
            const sub = item?.subActivityName;
            if (hasSubActivityName(sub) && !group.exercises.includes(sub)) {
                group.exercises.push(sub);
            }
        });
        return Array.from(map.values());
    };

    const mergeSummaryWithDetails = (summaryNames = [], detailFlat = []) => {
        const grouped = groupActivityDetails(detailFlat);
        const byName = new Map(grouped.map((g) => [g.activityName, g]));
        (summaryNames || []).forEach((entry) => {
            const name = typeof entry === "string" ? entry : entry?.activityName;
            if (name && !byName.has(name)) {
                byName.set(name, { activityName: name, exercises: [] });
            }
        });
        return Array.from(byName.values());
    };

    const fetchActivityDetails = async (keys = []) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const resolvedSchoolId =
            report?.schooleId?._id ||
            report?.schooleId ||
            report?.schoolId?._id ||
            report?.schoolId ||
            null;
        const baseBody = {
            schooleId: resolvedSchoolId,
            studentId,
            classId,
            isFuturePlanning: false,
        };

        const requests = keys.length
            ? keys.map((key) => ActivityService.findActivityList({ ...baseBody, key }))
            : [ActivityService.findActivityList(baseBody)];

        const results = await Promise.all(requests);
        return results.flatMap((result) => getActivityDetailsFromResponse(result));
    };

    const groupExercisesByActivity = (exercises = []) => {
        const map = new Map();
        (Array.isArray(exercises) ? exercises : []).forEach((item) => {
            const activityName = item?.activityName || item?.activity || "";
            const subActivityName = item?.subActivityName || item?.exerciseName || item?.subActivity || "";
            if (!activityName) return;
            if (!map.has(activityName)) map.set(activityName, new Set());
            if (subActivityName) map.get(activityName).add(subActivityName);
        });
        return Array.from(map.entries()).map(([activityName, set]) => ({
            activityName,
            exercises: Array.from(set.values()),
        }));
    };

    const openActivityExerciseDialog = (title, exercises = []) => {
        const groups = groupExercisesByActivity(exercises);
        setIsActivityDialogLoading(false);
        setActivityDialog({
            open: true,
            title,
            items: groups,
        });
    };

    const openActivityDialog = async (title, summaryNames = [], keys = []) => {
        const hasSummary = Array.isArray(summaryNames) && summaryNames.length > 0;
        const initialGroups = mergeSummaryWithDetails(summaryNames, []);

        setActivityDialog({
            open: true,
            title,
            items: initialGroups,
        });

        try {
            setIsActivityDialogLoading(true);
            const fetchedFlat = await fetchActivityDetails(keys);
            const merged = mergeSummaryWithDetails(summaryNames, fetchedFlat);
            setActivityDialog({
                open: true,
                title,
                items: merged.length > 0 ? merged : initialGroups,
            });
        } catch (error) {
            console.error("Error fetching activity details", error);
            setActivityDialog({
                open: true,
                title,
                items: initialGroups,
            });
        } finally {
            setIsActivityDialogLoading(false);
        }
    };

    const closeActivityDialog = () => {
        setActivityDialog({ open: false, title: "", items: [] });
        setIsActivityDialogLoading(false);
    };

    const attendanceTotal = monthWiseAttendance.reduce((sum, row) => sum + (Number(row.totalCount) || 0), 0);
    const totalPresent = monthWiseAttendance.reduce((sum, row) => sum + (Number(row.presentCount) || 0), 0);
    const assignmentPending = Number(studentEvent.notSubmitted) || 0;

    const openMilestoneLightbox = (index) => {
        setMilestoneLightbox({ open: true, index });
    };

    const renderMilestoneMediaTile = (url, album, globalIndex) => {
        const mediaType = getMediaTypeFromUrl(url);
        const label = album.eventName || "Memory";

        const tileProps = {
            className: classes.milestonePhotoTile,
            onClick: () => openMilestoneLightbox(globalIndex),
            role: "button",
            tabIndex: 0,
            onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    openMilestoneLightbox(globalIndex);
                }
            },
        };

        if (mediaType === "video") {
            return (
                <Box {...tileProps}>
                    <Box className={classes.milestoneMediaPlayTile}>
                        <VideocamIcon style={{ fontSize: 28, marginBottom: 4 }} />
                        <PlayArrowIcon style={{ fontSize: 36 }} />
                    </Box>
                    <span className={classes.milestoneMediaTypeBadge}>Video</span>
                </Box>
            );
        }

        if (mediaType === "audio") {
            return (
                <Box {...tileProps}>
                    <Box className={classes.milestoneMediaAudioTile}>
                        <AudiotrackIcon style={{ fontSize: 32 }} />
                        <Typography variant="caption" style={{ fontWeight: 700, color: "#1769d6" }}>
                            Audio
                        </Typography>
                    </Box>
                    <span className={classes.milestoneMediaTypeBadge}>MP3</span>
                </Box>
            );
        }

        return (
            <Box {...tileProps}>
                <img
                    src={url}
                    alt={label}
                    className={classes.milestonePhotoImage}
                    loading="lazy"
                />
            </Box>
        );
    };

    const renderMilestoneAlbumMedia = (album, albumIndex) => {
        const imageUrls = (album.imageURL || []).filter(Boolean);
        const videoUrls = (album.videoURL || []).filter(Boolean);
        const startIndex = milestoneAlbumStarts[albumIndex] || 0;
        const grouped = {
            image: groupMilestoneMediaByType(imageUrls).image,
            video: [
                ...groupMilestoneMediaByType(imageUrls).video,
                ...videoUrls.map((url, index) => ({ url, index: imageUrls.length + index })),
            ],
            audio: groupMilestoneMediaByType(imageUrls).audio,
        };
        const sections = [
            { key: "image", label: "Photos", items: grouped.image },
            { key: "video", label: "Videos", items: grouped.video },
            { key: "audio", label: "Audio", items: grouped.audio },
        ].filter((section) => section.items.length > 0);

        return sections.map((section) => (
            <Box key={`${album._id}-${section.key}`} style={{ width: "100%", marginBottom: 8 }}>
                <Typography className={classes.milestoneSectionLabel}>
                    {section.label} ({section.items.length})
                </Typography>
                <Grid container spacing={1.5}>
                    {section.items.map(({ url, index: localIdx }) => (
                        <Grid item xs={6} sm={4} md={3} key={`${album._id}-${section.key}-${localIdx}`}>
                            {renderMilestoneMediaTile(url, album, startIndex + localIdx)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        ));
    };

    const currentMilestoneItem = milestoneMediaItems[milestoneLightbox.index];

    return (
        <Box className={classes.pageContainer}>
            {studentList.length > 1 && (
                <Card className={classes.studentSelectorCard}>
                    <Box style={{ margin: 8 }}>
                        <StudentCards
                            studentList={studentList}
                            onStudentSelect={handleStudentClick}
                            selectedStudentId={selectedStudentId}
                        />
                    </Box>
                </Card>
            )}

            <Typography variant="h5" className={classes.sectionTitle}>
                My Story
            </Typography>

            <Card className={classes.heroCard} elevation={0}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={8}>
                        <Typography variant="body2" className={classes.introLabel}>
                            Student profile
                        </Typography>
                        <Typography variant="h4" className={classes.heroName}>
                            {selectedStudent?.fullName || "Select a student"}
                        </Typography>

                        <Grid container spacing={2} className={classes.infoGrid}>
                            <Grid item xs={12} sm={6}>
                                <Box className={classes.infoCard}>
                                    <Typography className={classes.infoLabel}>Age</Typography>
                                    <Typography className={classes.infoValue}>
                                        {selectedStudent?.age ?? "-"}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box className={classes.infoCard}>
                                    <Typography className={classes.infoLabel}>Class</Typography>
                                    <Typography className={classes.infoValue}>
                                        {selectedStudent?.classId?.className || "N/A"}
                                        {selectedStudent?.sectionId?.sectionName
                                            ? ` / ${selectedStudent.sectionId.sectionName}`
                                            : ""}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Typography variant="body2" className={classes.heroDescription}>
                            I&apos;m a student at Montessori School, and I love learning through exploring
                            and discovering new things. I was born global, and I&apos;ve always been
                            curious about the world around me, whether it&apos;s how plants grow or how
                            colors mix to make new shades.
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box className={classes.avatarWrap}>
                            <Avatar
                                src={selectedStudent?.profileURL || selectedStudent?.imageURL?.[0] || "/images/Admin icon.svg"}
                                className={classes.heroAvatar}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Card>

            {/* <Grid container spacing={3} className={classes.statsGrid}>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Attendance Days</Typography>
                        <Typography className={classes.statValue}>{attendanceTotal}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Present Days</Typography>
                        <Typography className={classes.statValue}>{totalPresent}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Pending Assignments</Typography>
                        <Typography className={classes.statValue}>{assignmentPending}</Typography>
                    </Box>
                </Grid>
            </Grid> */}

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Attendance
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Month</TableCell>
                                    <TableCell className={classes.headCell} align="center">Present</TableCell>
                                    <TableCell className={classes.headCell} align="center">Absent</TableCell>
                                    <TableCell className={classes.headCell} align="center">Late Coming</TableCell>
                                    <TableCell className={classes.headCell} align="center">Early Going</TableCell>
                                    <TableCell className={classes.headCell} align="center">Total</TableCell>
                                    <TableCell className={classes.headCell} align="center">Present %</TableCell>
                                    <TableCell className={classes.headCell} align="center">Absent %</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {monthWiseAttendance.length > 0 ? (
                                    monthWiseAttendance.map((row, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell className={classes.bodyCell}>{getMonthName(row._id?.month)} {row._id?.year}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell} style={{ color: "#15803d", fontWeight: 700 }}>
                                                {row.presentCount}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell} style={{ color: "#dc2626", fontWeight: 700 }}>
                                                {row.absentCount}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>
                                                {row.lateComingCount || 0}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>
                                                {row.earlyGoingCount || 0}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.totalCount}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.presentPercentage}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.absentPercentage}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" className={classes.emptyState}>
                                            No attendance data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Activity Performance Report
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Activity</TableCell>
                                    <TableCell className={classes.headCell} align="center">Strong Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Developing Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Need Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow hover>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <Button
                                            className={classes.clickableButton}
                                            onClick={() =>
                                                openActivityExerciseDialog(
                                                    "All Activities",
                                                    activityPerformance.totalActivityExercises || []
                                                )
                                            }
                                        >
                                            {activityPerformance.totalActivities || 0}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <Button
                                            className={classes.clickableButton}
                                            onClick={() =>
                                                openActivityExerciseDialog(
                                                    "Strong Area Activities",
                                                    activityPerformance.strongAreaExercises || []
                                                )
                                            }
                                        >
                                            {activityPerformance.strongArea || 0}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <Button
                                            className={classes.clickableButton}
                                            onClick={() =>
                                                openActivityExerciseDialog(
                                                    "Developing Area Activities",
                                                    activityPerformance.developingAreaExercises || []
                                                )
                                            }
                                        >
                                            {activityPerformance.developingArea || 0}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <Button
                                            className={classes.clickableButton}
                                            onClick={() =>
                                                openActivityExerciseDialog(
                                                    "Need Action Activities",
                                                    activityPerformance.needsActionExercises || []
                                                )
                                            }
                                        >
                                            {activityPerformance.needsAction || 0}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Assignments
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Number Of Assignments</TableCell>
                                    <TableCell className={classes.headCell} align="center">Submitted</TableCell>
                                    <TableCell className={classes.headCell} align="center">Not Submitted</TableCell>
                                    <TableCell className={classes.headCell} align="center">Resubmit Requested</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow hover>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.total || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.submitted || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.notSubmitted || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        {(studentEvent.resubmitRequestedInSubmitted || 0) +
                                            (studentEvent.resubmitRequestedInNotSubmitted || studentEvent.resubmitNotSubmitted || 0)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.notesSectionCard}>
                    <Box className={classes.notesSectionHeader}>
                        <Box className={classes.notesHeaderIcon}>
                            <EventNoteIcon />
                        </Box>
                        <Box>
                            <Typography className={classes.notesHeaderTitle}>
                                Notes For Report
                            </Typography>
                            <Typography className={classes.notesHeaderSubtitle}>
                                View notes added by teachers and schools
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={classes.notesTabsWrap}>
                        <Tabs
                            value={notesTab}
                            onChange={handleNotesTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            className={classes.notesTabs}
                        >
                            <Tab
                                className={classes.notesTab}
                                classes={{ selected: classes.notesTabSelected }}
                                value="all"
                                label={(
                                    <span className={classes.notesTabLabel}>
                                        <FormatListBulletedIcon style={{ fontSize: 18 }} />
                                        All ({studentNotesList.length})
                                    </span>
                                )}
                            />
                            <Tab
                                className={classes.notesTab}
                                classes={{ selected: classes.notesTabSelected }}
                                value="teacher"
                                label={(
                                    <span className={classes.notesTabLabel}>
                                        <PersonOutlineIcon style={{ fontSize: 18 }} />
                                        Teacher ({teacherNotesCount})
                                    </span>
                                )}
                            />
                            <Tab
                                className={classes.notesTab}
                                classes={{ selected: classes.notesTabSelected }}
                                value="school"
                                label={(
                                    <span className={classes.notesTabLabel}>
                                        <BusinessIcon style={{ fontSize: 18 }} />
                                        School ({schoolNotesCount})
                                    </span>
                                )}
                            />
                        </Tabs>
                    </Box>

                    <Box className={classes.notesListWrap}>
                        {notesLoading ? (
                            <Box className={classes.notesEmptyState} display="flex" justifyContent="center" alignItems="center" gridGap={12}>
                                <CircularProgress size={24} />
                                <Typography variant="body2">Loading notes...</Typography>
                            </Box>
                        ) : paginatedStudentNotes.length > 0 ? (
                            paginatedStudentNotes.map((note) => {
                                const teacher = isTeacherNote(note);
                                return (
                                    <Box key={note._id} className={classes.noteListCard}>
                                        <Box
                                            className={`${classes.noteTypeIconBox} ${teacher ? classes.noteTypeIconTeacher : classes.noteTypeIconSchool}`}
                                        >
                                            {teacher ? (
                                                <CreateIcon style={{ fontSize: 22 }} />
                                            ) : (
                                                <BusinessIcon style={{ fontSize: 22 }} />
                                            )}
                                        </Box>
                                        <Box className={classes.noteCardBody}>
                                            <Typography className={classes.noteCardTitle}>
                                                {note.notes || "—"}
                                            </Typography>
                                            <Box className={classes.noteCardMeta}>
                                                <span className={classes.noteMetaItem}>
                                                    <CalendarTodayIcon style={{ fontSize: 14 }} />
                                                    {formatNoteDateTime(note.createdAt)}
                                                </span>
                                                <span className={classes.noteMetaDivider}>|</span>
                                                <Chip
                                                    size="small"
                                                    label={teacher ? "Teacher" : "School"}
                                                    className={`${classes.noteSourceChip} ${teacher ? classes.teacherChip : classes.schoolChip}`}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                );
                            })
                        ) : (
                            <Box className={classes.notesEmptyState}>
                                {selectedStudent
                                    ? `No ${notesTab === "all" ? "" : `${notesTab} `}notes available for this student.`
                                    : "Select a student to view notes."}
                            </Box>
                        )}
                    </Box>

                    {!notesLoading && filteredStudentNotes.length > 0 && (
                        <TablePagination
                            component="div"
                            className={classes.notesPagination}
                            count={filteredStudentNotes.length}
                            page={notesPage}
                            onPageChange={handleNotesPageChange}
                            rowsPerPage={notesRowsPerPage}
                            onRowsPerPageChange={handleNotesRowsPerPageChange}
                            rowsPerPageOptions={[5, 10, 25]}
                            labelDisplayedRows={({ from, to, count }) =>
                                `Showing ${from} to ${to} of ${count} note${count !== 1 ? "s" : ""}`
                            }
                        />
                    )}
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.notesSectionCard}>
                    <Box className={classes.notesSectionHeader}>
                        <Box className={classes.notesHeaderIcon}>
                            <RateReviewIcon />
                        </Box>
                        <Box>
                            <Typography className={classes.notesHeaderTitle}>
                                {questionnaireReport.title || "Teacher Assessment"}
                            </Typography>
                            <Typography className={classes.notesHeaderSubtitle}>
                                Questionnaire answers from teacherlesson
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={classes.questionnaireListWrap}>
                        {questionnaireLoading ? (
                            <Box className={classes.notesEmptyState} display="flex" justifyContent="center" alignItems="center" gridGap={12}>
                                <CircularProgress size={24} />
                                <Typography variant="body2">Loading assessment...</Typography>
                            </Box>
                        ) : questionnaireReport.rated && questionnaireReport.items.length > 0 ? (
                            <>
                                <Box className={classes.questionnaireMetaRow}>
                                    
                                    {questionnaireReport.assessedBy && (
                                        <Typography className={classes.questionnaireMetaText}>
                                            Assessed by {questionnaireReport.assessedBy.name}
                                            {questionnaireReport.assessedBy.updatedAt
                                                ? ` · ${formatNoteDateTime(questionnaireReport.assessedBy.updatedAt)}`
                                                : ""}
                                        </Typography>
                                    )}
                                </Box>
                                {questionnaireReport.items.map((item, index) => (
                                    <Box
                                        key={`${item.questionIndex}-${index}`}
                                        className={classes.questionnaireItem}
                                    >
                                        <Typography className={classes.questionnaireQuestion}>
                                            {index + 1}. {item.question}
                                        </Typography>
                                        <Typography className={classes.questionnaireAnswer}>
                                            {item.answer}
                                        </Typography>
                                    </Box>
                                ))}
                            </>
                        ) : (
                            <Box className={classes.notesEmptyState}>
                                {selectedStudent
                                    ? "No rated teacher assessment is available for this student yet."
                                    : "Select a student to view teacher assessment."}
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.notesSectionCard}>
                    <Box className={classes.notesSectionHeader}>
                        <Box className={classes.notesHeaderIcon}>
                            <PhotoLibraryIcon />
                        </Box>
                        <Box>
                            <Typography className={classes.notesHeaderTitle}>
                                MileStones &amp; Memories
                            </Typography>
                            <Typography className={classes.notesHeaderSubtitle}>
                                Published photos, videos, and audio from school events (draft albums are hidden)
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={classes.questionnaireListWrap}>
                        {milestoneLoading ? (
                            <Box className={classes.notesEmptyState} display="flex" justifyContent="center" alignItems="center" gridGap={12}>
                                <CircularProgress size={24} />
                                <Typography variant="body2">Loading memories...</Typography>
                            </Box>
                        ) : milestoneAlbums.length > 0 ? (
                            milestoneAlbums.map((album, albumIndex) => {
                                const mediaCount =
                                    (album.imageURL || []).filter(Boolean).length +
                                    (album.videoURL || []).filter(Boolean).length;
                                if (!mediaCount) return null;

                                return (
                                    <Box key={album._id} className={classes.milestoneAlbumCard}>
                                        <Typography className={classes.milestoneAlbumTitle}>
                                            {album.eventName || "Event"}
                                        </Typography>
                                        <Box className={classes.milestoneAlbumMeta}>
                                            <EventIcon style={{ fontSize: 16 }} />
                                            {formatMilestoneDate(album.date)}
                                            {album.academicYear && (
                                                <>
                                                    <span>·</span>
                                                    <span>{album.academicYear}</span>
                                                </>
                                            )}
                                        </Box>
                                        {renderMilestoneAlbumMedia(album, albumIndex)}
                                    </Box>
                                );
                            })
                        ) : (
                            <Box className={classes.notesEmptyState}>
                                {selectedStudent
                                    ? "No published photos, videos, or audio available for this student yet."
                                    : "Select a student to view milestones and memories."}
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>

            <Dialog
                open={milestoneLightbox.open}
                onClose={() => setMilestoneLightbox({ open: false, index: 0 })}
                maxWidth={false}
                PaperProps={{ className: classes.milestoneLightboxPaper }}
            >
                <Box className={classes.milestoneLightboxContent}>
                    <IconButton
                        className={classes.milestoneLightboxClose}
                        onClick={() => setMilestoneLightbox({ open: false, index: 0 })}
                        aria-label="Close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {milestoneMediaItems.length > 1 && (
                        <>
                            <IconButton
                                className={classes.milestoneLightboxNav}
                                style={{ left: 8 }}
                                onClick={() => setMilestoneLightbox((prev) => ({
                                    open: true,
                                    index: prev.index > 0 ? prev.index - 1 : milestoneMediaItems.length - 1,
                                }))}
                                aria-label="Previous"
                            >
                                <ChevronLeftIcon />
                            </IconButton>
                            <IconButton
                                className={classes.milestoneLightboxNav}
                                style={{ right: 8 }}
                                onClick={() => setMilestoneLightbox((prev) => ({
                                    open: true,
                                    index: prev.index < milestoneMediaItems.length - 1 ? prev.index + 1 : 0,
                                }))}
                                aria-label="Next"
                            >
                                <ChevronRightIcon />
                            </IconButton>
                        </>
                    )}
                    {currentMilestoneItem && currentMilestoneItem.mediaType === "video" && (
                        <video
                            key={currentMilestoneItem.url}
                            src={currentMilestoneItem.url}
                            controls
                            autoPlay
                            className={classes.milestoneLightboxVideo}
                        />
                    )}
                    {currentMilestoneItem && currentMilestoneItem.mediaType === "audio" && (
                        <Box className={classes.milestoneLightboxAudioWrap}>
                            <AudiotrackIcon style={{ color: "#1769d6", fontSize: 56, marginBottom: 16 }} />
                            <audio
                                key={currentMilestoneItem.url}
                                src={currentMilestoneItem.url}
                                controls
                                autoPlay
                                style={{ width: "100%" }}
                            />
                        </Box>
                    )}
                    {currentMilestoneItem && currentMilestoneItem.mediaType === "image" && (
                        <img
                            src={currentMilestoneItem.url}
                            alt={currentMilestoneItem.eventName}
                            className={classes.milestoneLightboxImage}
                        />
                    )}
                </Box>
                {currentMilestoneItem && (
                    <Box className={classes.milestoneLightboxFooter}>
                        <Typography className={classes.milestoneLightboxMeta}>
                            {currentMilestoneItem.eventName}
                            {currentMilestoneItem.date
                                ? ` · ${formatMilestoneDate(currentMilestoneItem.date)}`
                                : ""}
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.milestoneDownloadBtn}
                            startIcon={<GetAppIcon />}
                            onClick={() => downloadMilestoneMedia(
                                currentMilestoneItem.url,
                                currentMilestoneItem.eventName,
                                currentMilestoneItem.mediaType,
                            )}
                        >
                            Download
                        </Button>
                    </Box>
                )}
            </Dialog>

            <Dialog
                open={activityDialog.open}
                onClose={closeActivityDialog}
                maxWidth="sm"
                fullWidth
                PaperProps={{ className: classes.dialogPaper }}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">{activityDialog.title}</Typography>
                        <Chip
                            label={`${activityDialog.items.length} Activities`}
                            size="small"
                            style={{ backgroundColor: "#ffffff", color: "#1d4ed8", fontWeight: 700 }}
                        />
                    </Box>
                </DialogTitle>
                <DialogContent className={classes.dialogContent} dividers>
                    <Typography variant="body2" className={classes.dialogSubtitle}>
                        Activities and related exercises for the selected category.
                    </Typography>
                    {isActivityDialogLoading ? (
                        <Box className={classes.emptyState}>Loading activities...</Box>
                    ) : activityDialog.items.length > 0 ? (
                        <List className={classes.dialogList}>
                            {activityDialog.items.map((group, index) => (
                                <ListItem
                                    key={`${group?.activityName || "activity"}-${index}`}
                                    className={classes.activityItem}
                                >
                                    <Box className={classes.activityIndex}>{index + 1}</Box>
                                    <Box flex={1}>
                                        <Typography className={classes.activityName}>
                                            {group?.activityName || "N/A"}
                                        </Typography>
                                        {group.exercises && group.exercises.length > 0 ? (
                                            <Box component="ul" style={{ margin: "8px 0 0", paddingLeft: 20 }}>
                                                {group.exercises.map((exercise, exIdx) => (
                                                    <Box
                                                        component="li"
                                                        key={`${group.activityName}-ex-${exIdx}`}
                                                        style={{ marginBottom: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            style={{ color: "#334155", fontWeight: 500 }}
                                                        >
                                                            {exercise}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        ) : (
                                            <Typography
                                                variant="caption"
                                                style={{ color: "#94a3b8", marginTop: 6, display: "block" }}
                                            >
                                                No exercise recorded
                                            </Typography>
                                        )}
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Box className={classes.emptyState}>No activities available</Box>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button
                        onClick={closeActivityDialog}
                        color="primary"
                        variant="contained"
                        className={classes.closeButton}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
